/**
 * Transform a StopPlaceRef object to a Place object
 *
 * @param stopPlaceRef
 * @returns The Place object
 */
export function transformPlace(stopPlaceRef?: ApiSchema['StopPlaceRef']): Place {
    return {
        ref: stopPlaceRef?.stopPlaceRef ?? '',
        name: stopPlaceRef?.stopPlaceName ?? '',
    };
}
